import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Audiencia } from '../types/Audiencia/Audiencia';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIAUDIENCIA = 'api/Catalog/Audiencia/';

export default class AudienciaService {

    static async GetAudiencias(): Promise<Array<Audiencia>> {
        const response1: AxiosResponse<Array<Audiencia>> = await apiInterceptor.get(`${SERV_BACK}${APIAUDIENCIA}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

}